import { PubIdent } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('PubIdent')

export default {
  label: 'PubIdent',
  route: 'pubident',
  class: PubIdent,
  className: 'pubIdent',
  fields: [
    Fields.String('wert'),
    Fields.PrefetchedSingleReference(
      'pubIdentTyp',
      'pubIdentTyp',
      'folder-open'
    )
  ]
}



// WEBPACK FOOTER //
// ./src/schema/PubIdent.js